module.exports = __webpack_public_path__ + "img/salsa-1.1d880f26.jpg";